import { EventEmitter } from "pixi.js";


export enum EnumEventBus {
    moveCircumPoint = "MOVE_CIRCUMFERENCE_POINT",
    moveChordA = "MOVE_CHORD_A",
    moveChordB = "MOVE_CHORD_B",
    setPointChecklist = "SET_POINT_CHECK_LIST"
}


export const eventBus = new EventEmitter();